export default __webpack_public_path__ + "static/media/openinterest.65c97db5.png";